import { Button, IconButton, useTheme } from '@mui/material';
import { Doc } from 'src/@types/docs';
import Iconify from 'src/components/iconify';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { useLocales } from 'src/locales';
import { useDocHeaderActions } from './useDocHeaderActions';

export const NewDocButton = ({ doc }: { doc: Doc }) => {
  const { handleCreateDoc } = useDocHeaderActions({ doc });
  const { translate } = useLocales();
  const { isSmallMobile } = useBreakpoints();
  const theme = useTheme();

  if (isSmallMobile) {
    return (
      <IconButton onClick={() => handleCreateDoc()}>
        <Iconify icon="eva:plus-fill" color={theme.palette.primary.main} />
      </IconButton>
    );
  }

  return (
    <Button
      variant="outlined"
      startIcon={<Iconify icon="eva:plus-fill" />}
      onClick={() => handleCreateDoc()}
    >
      {translate('shared.buttons.new')}
    </Button>
  );
};
